export default {
	name: 'Modal',
	props: {
		show: {
			type: Boolean,
			default: false,
		},
		closeClass: {
			type: String,
			default: ''
		},
	},
	watch: {
		show(isShowing) {
			if (isShowing) {
				document.querySelector('html').style.overflow = 'hidden';
				this.open();
			} else {
				document.querySelector('html').attributes.removeNamedItem('style')
			}
		},
	},
	methods: {
		open() {
			this.$emit('open')
		},
		close() {
			this.$emit('close')
		},
	},
	template: `
	<div class="modal" v-show="show">
		<div class="modal__backdrop" @click="close"></div>
		<div class="modal__container">
			<div :class="['modal__close', closeClass]" @click="close"></div>
			<slot></slot>
		</div>
	</div>`,
}
